export const url="https://vatanparvar.uz/Files/News"
export const api="https://vatanparvar.uz"

export const urlFoto="https://vatanparvar.uz/Files/Photogallery"
export const urlStat="https://vatanparvar.uz/Files/StatisticElements"
export const urlPer="https://vatanparvar.uz/Files/Personal"